
import { UseModal } from '@/composable/useModal'
import { computed, defineComponent, inject, ref } from 'vue'
import { DeviationDelayMpkModalData } from '@/types/deviation-delay-mpk-modal-data'
import { format } from 'date-fns'

export default defineComponent({
  name: 'DeviationDelayMPKModal',

  setup() {
    const showRawdata = ref(false)
    const modal =
      inject<UseModal<DeviationDelayMpkModalData>>('delay-mpk-modal')!
    const { eventId, mpkData } = modal.state.data!

    const signatures = computed(() => {
      const data = mpkData as any as {
        SelectedSection: {
          FromLocation: { AdvertisedLocationName: string; Signature: string }
        }[]
      }
      if (!data.SelectedSection) return '-'

      return data.SelectedSection.map(
        (x) => x.FromLocation.AdvertisedLocationName || x.FromLocation.Signature
      ).join(', ')
    })

    const reason = computed(() => {
      const data = mpkData as any as {
        ReasonCode: string
        ReasonInternalDescription?: string
      }

      return data.ReasonInternalDescription || data.ReasonCode
    })

    const operativeEventDescription = computed(() => {
      const data = mpkData as any as {
        OperativeEvent: { EventType: { Description: string } }
      }
      if (!data.OperativeEvent) return ''

      return data.OperativeEvent.EventType.Description
    })

    const railwayInternalEventInformation = computed(() => {
      const data = mpkData as any as {
        RailwayInternalEventInformation: string
      }

      if (!data.RailwayInternalEventInformation) return ''

      return data.RailwayInternalEventInformation.replace(/\r\n?/g, '\n')
        .replace(/\n+/g, '\n')
        .replace(/\n/g, '\n\n')
    })

    const trafficMessagePublicMessage = computed(() => {
      const data = mpkData as any as {
        OperativeEvent: {
          TrafficImpact: {
            PublicMessage: {
              Description: string
              Header: string
              ModifiedDateTime: string
            }
          }[]
        }
      }
      if (
        !data.OperativeEvent ||
        !data.OperativeEvent.TrafficImpact ||
        !data.OperativeEvent.TrafficImpact.length
      )
        return []

      return data.OperativeEvent.TrafficImpact.filter(
        (x) => x.PublicMessage
      ).map((x) => ({
        label: `Operative Event - Traffic Impact - PublicMessage`,
        header: `${format(
          new Date(x.PublicMessage.ModifiedDateTime),
          'yyyy-MM-dd HH:mm:ss'
        )} - ${x.PublicMessage.Header}`,
        value: x.PublicMessage.Description,
      }))
    })

    const headers = [
      {
        label: 'Rubrik',
        key: 'Header',
      },
      {
        label: 'Händelsebeskrivning (intern)',
        key: 'InternalText',
      },
      {
        label: 'Händelsebeskrivning (extern)',
        key: 'ExternalDescription',
      },
    ]

    return {
      modal,
      eventId,
      mpkData,
      headers,
      showRawdata,
      signatures,
      operativeEventDescription,
      trafficMessagePublicMessage,
      railwayInternalEventInformation,
      reason,
    }
  },
})
